import React, { useEffect } from 'react';
import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';
import { ManualUpload } from 'routes/paths';
import { Button } from '@mui/material';
import styles from './index.module.scss';
import { DocumentTypeEnum } from 'common/document/enums/document-type.enum';

export interface ManualUploadButtonProps {
  isLoading?: string;
  withTimeout?: boolean;
  timeout?: number;
  onClick?: () => void;
  documentRequestId: string;
  documentId: string;
  documentType: string;
  documentTypeEnum?: DocumentTypeEnum;
  className?: string;
  showMessageBeforeTimeout?: boolean;
}

function ManualUploadButton(props: ManualUploadButtonProps) {
  const navigate = useNavigate();
  const [showAfterTimeOut, setShowAfterTimeOut] =
    React.useState<boolean>(false);
  const [showMessageTimeOut, setShowMessageTimeOut] =
    React.useState<boolean>(false);

  const goToManualUpload = () => {
    if (props.onClick) {
      props.onClick();
      return;
    }

    navigate(
      ManualUpload.replace(':documentRequestId', props.documentRequestId)
        .replace(':documentType', props.documentType)
        .replace(':documentTypeEnum', props.documentTypeEnum || '')
        .replace(':documentId', props.documentId)
    );
  };

  useEffect(() => {
    if (props.withTimeout) {
      const timeOutId = setTimeout(() => {
        setShowAfterTimeOut(true);
      }, props.timeout || 15000);

      let showMessageTimeOutId: NodeJS.Timeout | undefined;

      if (props.showMessageBeforeTimeout) {
        showMessageTimeOutId = setTimeout(() => {
          setShowMessageTimeOut(true);
        }, 5000);
      }

      return () => {
        clearTimeout(timeOutId);
        if (showMessageTimeOutId) {
          clearTimeout(showMessageTimeOutId);
        }
      };
    }
  }, []);

  if (props.showMessageBeforeTimeout) {
    return (
      <div className={clsx(styles.root, props.className)}>
        {!showAfterTimeOut && showMessageTimeOut && (
          <span>Tap to Take Photo</span>
        )}
        {showAfterTimeOut && (
          <Button onClick={goToManualUpload}>Upload Photo</Button>
        )}
      </div>
    );
  }

  if (props.withTimeout && !showAfterTimeOut) {
    return null;
  }

  return (
    <div className={clsx(styles.root, props.className)}>
      <Button onClick={goToManualUpload}>Upload Photo</Button>
    </div>
  );
}

export default ManualUploadButton;
